<script>
	import { clamp } from 'yootils';
    import { createEventDispatcher } from 'svelte';
	import { onMount } from 'svelte';
	export let start = min;
	export let end = max;
    export let min = 0;  // default minimum
    export let max = 100; // default maximum
    export let step = 1; // default step

    const dispatch = createEventDispatcher();

    onMount(() => {
        start = min;
        end = max;
    });

    $: if (typeof start === 'undefined' || start < min) start = min;
    $: if (typeof end === 'undefined' || end > max) end = max;

    $: {
        if (typeof start !== 'undefined' && typeof end !== 'undefined') {
            dispatch('change', { start, end });
        }
    }

	let leftHandle;
	let body;
	let slider;

    function toPercentage(value) {
        return (value - min) / (max - min);
    }

    function fromPercentage(percentage) {
        return min + percentage * (max - min);
    }

	function draggable(node) {
		let x;
		let y;
		function handleMousedown(event) {
			if (event.type === 'touchstart') {
				event = event.touches[0];
			}
			x = event.clientX;
			y = event.clientY;
			node.dispatchEvent(new CustomEvent('dragstart', {
				detail: { x, y }
			}));
			window.addEventListener('mousemove', handleMousemove);
			window.addEventListener('mouseup', handleMouseup);
			window.addEventListener('touchmove', handleMousemove);
			window.addEventListener('touchend', handleMouseup);
		}
		function handleMousemove(event) {
			if (event.type === 'touchmove') {
				event = event.changedTouches[0];
			}
			const dx = event.clientX - x;
			const dy = event.clientY - y;
			x = event.clientX;
			y = event.clientY;
			node.dispatchEvent(new CustomEvent('dragmove', {
				detail: { x, y, dx, dy }
			}));
		}
		function handleMouseup(event) {
			x = event.clientX;
			y = event.clientY;
			node.dispatchEvent(new CustomEvent('dragend', {
				detail: { x, y }
			}));
			window.removeEventListener('mousemove', handleMousemove);
			window.removeEventListener('mouseup', handleMouseup);
			window.removeEventListener('touchmove', handleMousemove);
			window.removeEventListener('touchend', handleMouseup);
		}
		node.addEventListener('mousedown', handleMousedown);
		node.addEventListener('touchstart', handleMousedown);
		return {
			destroy() {
				node.removeEventListener('mousedown', handleMousedown);
				node.removeEventListener('touchstart', handleMousedown);
			}
		};
	}

	function setHandlePosition (which) {
		return function (evt) {
			const { left, right } = slider.getBoundingClientRect();
			const parentWidth = right - left;
			let p = Math.min(Math.max((evt.detail.x - left) / parentWidth, 0), 1);
			let actualValue = fromPercentage(p);

            // Round to the nearest step
            actualValue = Math.round((actualValue - min) / step) * step + min;

            if (which === 'start') {
                start = actualValue;
                end = Math.max(end, start);
            } else {
                start = Math.min(end, start);
                end = actualValue;
            }
		}
	}
    
	function setHandlesFromBody (evt) {
		const { width } = body.getBoundingClientRect();
		const { left, right } = slider.getBoundingClientRect();
		const parentWidth = right - left;
		const leftHandleLeft = leftHandle.getBoundingClientRect().left;
		const pxStart = clamp((leftHandleLeft + event.detail.dx) - left, 0, parentWidth - width);
		const pxEnd = clamp(pxStart + width, width, parentWidth);
		const pStart = pxStart / parentWidth;
		const pEnd = pxEnd / parentWidth;
        const actualStart = fromPercentage(pStart);
        const actualEnd = fromPercentage(pEnd);

		// Round to the nearest step
        start = Math.round(actualStart / step) * step;
        end = Math.round(actualEnd / step) * step;
	}
</script>

<div class="double-range-container">
	<div class="slider" bind:this={slider}>
		<div
			class="body"
			bind:this={body}
			
			on:dragmove|preventDefault|stopPropagation="{setHandlesFromBody}"
			style="
				left: {100 * toPercentage(start)}%;
				right: {100 - 100 * toPercentage(end)}%;
			"
			></div>
		<div
			class="handle"
			bind:this={leftHandle}
			data-which="start"
			use:draggable
			on:dragmove|preventDefault|stopPropagation="{setHandlePosition('start')}"
			style="
				left: {100 * toPercentage(start)}%
			"
		></div>
		<div
			class="handle"
			data-which="end"
			use:draggable
			on:dragmove|preventDefault|stopPropagation="{setHandlePosition('end')}"
			style="
				left: {100 * toPercentage(end)}%
			"
		></div>
	</div>
</div>

<style>
    :root {
		--primary-color: #aa9173;
	}
	.double-range-container {
		width: 100%;
		height: 20px;
		user-select: none;
		box-sizing: border-box;
		white-space: nowrap
	}
	.slider {
        -webkit-appearance: none;
        appearance: none;
		position: relative;
		width: 100%;
		height: 1px;
        background: white;
        border: 1px solid #a8a8a8d2;
        outline: none;
        opacity: 0.7;
        -webkit-transition: 0.2s;
		transition: opacity 0.2s;
		user-select: none;
    }
    .slider:hover {
        opacity: 1;
    }
	.handle {
		position: absolute;
		top: 50%;
		width: 0;
		height: 0;
	}
	.handle:after {
		content: ' ';
		box-sizing: border-box;
		position: absolute;
		width: 25px;
		height: 25px;
		background-color: var(--primary-color);
		transform: translate(-50%, -50%)
	}
	.handle:active:after {
		z-index: 9;
	}
	.body {
		top: -1px;
		position: absolute;
		background-color: white;
        border: 2px solid var(--primary-color);
		bottom: 1px;
	}
</style>